import { useRef } from 'react';
import { isEqual } from 'es-toolkit/compat';

export function useDeepCompareMemoize(value: unknown[]) {
  const ref = useRef<unknown[]>([]);

  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}
